import React from "react";

interface MarkerProps extends google.maps.MarkerOptions {
    onDragEnd?: (e: google.maps.MapMouseEvent) => void;
}

const Marker: React.FC<MarkerProps> = ({onDragEnd, ...options}) => {
    const [marker, setMarker] = React.useState<google.maps.Marker>();

    React.useEffect(() => {
        if (!marker) {
            setMarker(new google.maps.Marker());
        }

        // remove marker from map on unmount
        return () => {
            if (marker) {
                marker.setMap(null);
            }
        };
    }, [marker]);

    React.useEffect(() => {
        if (marker) {
            marker.setOptions(options);
        }
    }, [marker, options]);

    React.useEffect(() => {
        if (marker) {
            google.maps.event.clearListeners(marker, "dragend");

            if(onDragEnd) {
                marker.addListener("dragend", onDragEnd);
            }
        }

    }, [marker, onDragEnd]);

    return null;
};

export default Marker;